import { Divider } from '@material-ui/core'
import React from 'react'
import styles from './quilt.module.scss'
import QuiltBrowser from './QuiltBrowser'
import QuiltPreviewWrapper from './QuiltPreviewWrapper'
import quiltType from './quiltType'
import Stage from 'components/Designer/Stage'
import Quilt from 'designer/geoHandlers/Material/quilt'

const QuiltWrapper = ({
  quiltCurrent,
}: {
  quiltCurrent: quiltType | undefined
}) => {
  const colors = [
    '#000000',
    '#b3b3b3',
    '#5e3215',
    '#c9b697',
    '#a81414',
    '#05fa11',
    '#1d76c4',
    '#fae505',
  ]
  const stage = Stage.getInstance()
  return (
    <div className={styles.quiltRoot}>
      <div
        style={{
          display: 'flex',
          width: '100%',
          justifyContent: 'space-evenly',
          // overflow: 'hidden',
          alignItems: 'center',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            width: '30%',
            maxHeight: '250px',
            flexWrap: 'wrap',
            alignItems: 'center',
          }}
        >
          {colors.map(c => (
            <div
              key={c}
              style={{
                width: '50px',
                height: '50px',
                backgroundColor: `${c}`,
                margin: '.25rem',
                cursor: 'pointer',
                borderRadius: '4px',
                border: '1px solid #888888',
              }}
              onClick={() => {
                {
                  Quilt.setColor(c)
                  /* stage.quilt = { stitchColor: c } */
                }
              }}
            />
          ))}
        </div>
        <QuiltPreviewWrapper selectedQuilt={quiltCurrent} />
      </div>
      <Divider />
      <QuiltBrowser />
      <Divider />
    </div>
  )
}
export default QuiltWrapper
